import axios, { AxiosError, AxiosRequestConfig } from "axios";
import endpoints from "./endpoints";
import router from "../router/index";
import emitter from "tiny-emitter/instance";
import eventLogger from "./ApiLogger/EventLogger";
import _ from "lodash";
import Qs from "qs";

function errorHandler(error: AxiosError) {
  if (error && error.response && error.response.status === 401) {
    console.error("current route", router.currentRoute);
    // Redirect to Logout page on Unauthorised access or Session expire
    if (
      router.currentRoute.value.name != "login" &&
      router.currentRoute.value.name != "logout" &&
      router.currentRoute.value.name != "login-provider" &&
      !!router.currentRoute.value.name
    ) {
      router.push({
        name: "logout",
        query: { go: router.currentRoute.value.fullPath }
      });
      console.info("Api returned an authorization error. Redirecting to login page.", error.message);
    } else {
      console.info("Api returned an authorization error. Already in login page. authorization error ignored.", error.message);
    }
  } else {
    const isNotifiableStatusCode = (x: number) => x >= 500 || x == 403;
    if (error.isAxiosError && error.response && isNotifiableStatusCode(error.response.status)) {
      console.warn("Api exception received. An error alert has triggered", error);
      emitter.emit("global-error", { type: "api", exception: error });
    } else if (error.message == "Network Error") {
      console.warn("Network seems to be offline. A warning alert has triggered", error);
      emitter.emit("global-error", { type: "network", exception: error });
    } else {
      console.error("Api call failed with error. No error alert produced.", error);
    }
  }
}

export default {
  get: async function (url: string, config?: Record<string, unknown>, preventformat?: boolean) {
    url = preventformat || !config ? url : endpoints.format(url, config.params || {});
    eventLogger.info("api-request", "Initiating api request", {
      url,
      ..._.cloneDeep(config)
    });
    config = config || {};

    /*eslint-disable  @typescript-eslint/no-explicit-any*/
    config.paramsSerializer = function (params: Record<string, any>) {
      return Qs.stringify(params, { arrayFormat: "repeat" });
    };

    try {
      return await axios.get(url, config);
    } catch (error) {
      errorHandler(error as AxiosError);
      throw error;
    } finally {
      eventLogger.info("api-request", "api request completed", {
        url,
        ..._.cloneDeep(config)
      });
    }
  },

  post: async function (url: string, data?: unknown, config?: Record<string, unknown> | AxiosRequestConfig<unknown>, preventformat?: boolean) {
    url = preventformat || !data ? url : endpoints.format(url, data || {});
    eventLogger.info("api-request", "Initiating api request", {
      url,
      ..._.cloneDeep(config)
    });

    try {
      return await axios.post(url, data, config);
    } catch (error) {
      errorHandler(error as AxiosError);
      throw error;
    } finally {
      eventLogger.info("api-request", "api request completed", {
        url,
        ..._.cloneDeep(config)
      });
    }
  },

  put: async function (url: string, data?: Record<string, unknown>, config?: Record<string, unknown>, preventformat?: boolean) {
    url = preventformat || !data ? url : endpoints.format(url, data || {});
    eventLogger.info("api-request", "Initiating api request", {
      url,
      ..._.cloneDeep(config)
    });
    try {
      return await axios.put(url, data, config);
    } catch (error) {
      errorHandler(error as AxiosError);
      throw error;
    } finally {
      eventLogger.info("api-request", "api request completed", {
        url,
        ..._.cloneDeep(config)
      });
    }
  },
  delete: async function (url: string, config?: Record<string, unknown>, preventformat?: boolean) {
    url = preventformat || !config ? url : endpoints.format(url, config.params || {});
    eventLogger.info("api-request", "Initiating api request", {
      url,
      ..._.cloneDeep(config)
    });
    try {
      return await axios.delete(url, config);
    } catch (error) {
      errorHandler(error as AxiosError);
      throw error;
    } finally {
      eventLogger.info("api-request", "api request completed", {
        url,
        ..._.cloneDeep(config)
      });
    }
  }
};
